import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import SelectSiteListModal from "../../assets/SelectSiteListModal";
import pick from 'lodash.pick';
import MapGetPoint from '@/components/Map/MapGetPoint';
import { httpAction } from '@/api/manage';
export default {
  name: 'ManholeCoverModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '窨井表单',
      pointList: [],
      mapCenter: [],
      selectedUser: [],
      selectedSite: [],
      selectedSiteList: [[]],
      siteIds: '',
      tableName: 'env_manhole_cover',
      form_fields: ['pipeSystemId', 'siteId', 'mn', 'title', 'category', 'coordinate', 'addr', 'status', 'sort', 'remark'],
      form_fields_time: [],
      validatorRules: {
        pipeSystemId: {
          rules: [{
            required: true,
            message: '请输入管网!'
          }]
        },
        mn: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入类型!'
          }]
        },
        coordinate: {
          rules: [{
            required: true,
            message: '请输入坐标!'
          }]
        },
        addr: {
          rules: [{
            required: true,
            message: '请输入地址!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        siteId: {
          required: false,
          message: '请选择站点!'
        },
        selectedSite: {
          rules: [{
            required: false,
            message: '请选择关联站点!'
          }]
        }
      }
    };
  },
  components: {
    MapGetPoint: MapGetPoint,
    SelectSiteListModal: SelectSiteListModal
  },
  props: ['pagePath'],
  created: function created() {
    this.$store.state.projectCode == 'meitang' ? this.title = '化粪池' : '窨井';
  },
  methods: {
    // compareToFirstPassword(rule, value, callback) {
    // 	console.log('rule, value, callback',value)
    //   if (value==''||value==[]) {
    //     callback('请选择关联站点！');
    //   } else {
    //     callback()
    //   }
    // },
    handleOk: function handleOk() {
      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        // debugger
        if (!err) {
          that.confirmLoading = true;
          that.model.siteId = that.siteIds ? that.siteIds : null;
          var formData = Object.assign(that.model, values);
          formData.siteId = that.model.siteId ? that.model.siteId : null;
          var httpurl = '',
              method = '';

          if (!that.model.id) {
            httpurl = that.url.add ? that.url.add : that.pagePath;
            method = 'post';
          } else {
            httpurl = that.url.edit ? that.url.edit : that.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    selectSite: function selectSite(index) {
      if (index >= 0) {
        this.index = index; // this.selectedSiteList[this.index] = new Array()
      }

      this.$refs.SiteListModal.add(this.model.selectedSite, this.siteIds);
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      // debugger
      console.log(siteList);
      console.log(this.model);
      this.selectedSite = [];
      this.siteIds = '';

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSite.push(siteList[i].name);
        this.siteIds = siteList[i].id;

        if (this.showType == 1) {
          console.log(this.index);
          this.selectedSiteList[this.index].push(siteList[i].name);
          this.selectedSiteList[this.index] = this.selectedSiteList[this.index].reverse();
          this.formList[this.index].siteId = siteList[i].id;
          this.$forceUpdate;
        }
      }

      this.form.setFieldsValue({
        selectedSite: this.selectedSite
      });
      this.model.selectedSite = this.selectedSite;

      if (siteList.length > 0) {
        this.form.setFieldsValue({
          coordinate: siteList[0].longitude + ',' + siteList[0].latitude
        });
        this.model.coordinate = siteList[0].longitude + ',' + siteList[0].latitude;
        this.mapCenter.push(siteList[0].longitude);
        this.mapCenter.push(siteList[0].latitude); // this.$set(this.model,'coordinate',siteList[0].longitude+','+siteList[0].latitude)
      }
    },
    add: function add(pipeSystemId, pointList) {
      this.edit({}, pipeSystemId);
      this.pointList = pointList;
    },
    edit: function edit(record, pipeSystemId, pointList) {
      var _this = this;

      this.pointList = pointList;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      if (pipeSystemId != undefined) this.model.pipeSystemId = pipeSystemId;
      this.model.selectedSite = this.model.selectedSite ? this.model.selectedSite : record.siteName;
      this.visible = true;
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
        console.log(that.model);

        if (typeof that.model.longitude != 'undefined' && typeof that.model.latitude != 'undefined') {
          that.mapCenter.push(that.model.longitude);
          that.mapCenter.push(that.model.latitude);
        }

        _this.selectedSite = [];
        _this.siteIds = _this.model.siteId ? _this.model.siteId : null;

        _this.selectedSite.push(_this.model.siteName);

        _this.$refs.SiteListModal.edit(_this.selectedSite, _this.siteIds);

        console.log('this.selectedSite', _this.model.siteName);
        console.log('this.selectedSite', _this.selectedSite);

        _this.form.setFieldsValue({
          selectedSite: _this.selectedSite
        });

        _this.model.selectedSite = _this.selectedSite;
      });
    },
    coordinateChange: function coordinateChange() {
      this.$refs.mapLine.show(this.mapCenter, this.pointList);
    },
    coordinateOk: function coordinateOk(value) {
      var that = this;

      if (value != null) {
        this.form.setFieldsValue({
          coordinate: value ? value.join(',') : null
        });
        this.model.coordinate = value ? value.join(',') : null;
      }
    }
  }
};